import * as React from 'react';
import { type PropsWithChildren, createContext, useContext, useMemo } from 'react'
import type { ConversationProps } from '../types.js'

export const defaultLocaleText = {
  footer: {
    sendActionTooltip: 'Send',
  },
  editorPlaceholderText: 'Type a message...',
  header: {
    minimizeToolTip: 'Minimize',
    enterFullscreenToolTip: 'Toggle fullscreen',
    exitFullscreenToolTip: 'Exit fullscreen',
    clearChatToolTip: 'Clear chat',
    overflowMenuTooltip: 'More actions',
  },
  rating: {
    likeTooltip: 'Good response',
    dislikeTooltip: 'Bad response',
  },
  suggestionsControl: {
    trigger: {
      label: 'Suggestions',
    },
    suggestionsPanel: {
      title: 'Suggestions',
    },
  },
  scrollToBottomTooltip: 'Scroll to bottom',

  conversationEmpty: {
    title: 'How can I help you?',
  },
}

export type ConversationTexts = typeof defaultLocaleText

export const localeContext = createContext<ConversationTexts>(defaultLocaleText)

export function ConversationTextsProvider(props: PropsWithChildren<Pick<ConversationProps, 'localeText'>>) {
  const { children, localeText } = props

  const contextValue = useMemo<ConversationTexts>(
    () => ({
      ...defaultLocaleText,
      ...localeText,
    }),
    [localeText],
  )

  return <localeContext.Provider value={contextValue}>{children}</localeContext.Provider>
}

export function useConversationTexts() {
  return useContext(localeContext)
}
